import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import DevSecOpsSolutionsSection from "./components/DevSecOpsSolutionsSection";
import ExperienceSection from "./components/ExperienceSection";
import CaseStudiesSection from "./components/CaseStudiesSection";
import SkillsSection from "./components/SkillsSection";
import TerminalSection from "./components/TerminalSection";
import VideoSection from "./components/VideoSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import { AchievementProvider, AchievementButton, AchievementPanel } from "./components/AchievementSystem";

const Home = () => {
  return (
    <AchievementProvider>
      <div className="min-h-screen">
        <Navbar />
        <HeroSection />
        <DevSecOpsSolutionsSection />
        <ExperienceSection />
        <CaseStudiesSection />
        <SkillsSection />
        <TerminalSection />
        <VideoSection />
        <ContactSection />
        <Footer />
        <AchievementButton />
        <AchievementPanel />
      </div>
    </AchievementProvider>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
